import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Text } from 'office-ui-fabric-react/lib/Text';
import styles from './ModuleHeader.style';

const ModuleHeader = ({ variant, extra, children, className: classNameProp, ...other }) => {
  const className = clsx(styles.root, classNameProp);
  const asMap = {
    medium: 'h4',
    large: 'h3',
    xLarge: 'h2',
  };

  return (
    <div className={className} {...other}>
      <Text as={asMap[variant]} className={styles.title}>
        {children}
      </Text>
      {extra}
    </div>
  );
};

ModuleHeader.propTypes = {
  variant: PropTypes.oneOf(['medium', 'large', 'xLarge']),
  extra: PropTypes.node,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

ModuleHeader.defaultProps = {
  variant: 'medium',
  extra: '',
  className: '',
};

export default ModuleHeader;
